import React from "react";
import styles from "../NotFound/NotFound.module.scss";

const ActivatePage = () => {
  return (
    <div className={styles.notFoundPage}>
      <div className={styles.content}>
        <h2 className={styles.title}>Activate your account</h2>
        <p className={styles.description}>
          We’ve sent a confirmation email to your inbox.
          <br /> Please check your email and follow the instructions to activate
          your account.
        </p>
      </div>
      <a href="https://mail.google.com/" className={styles.notFoundButton}>
        Gmail
      </a>
    </div>
  );
};

export default ActivatePage;
